import { useTranslation } from 'react-i18next'
import { reasonColumnsClassName, shopifyReasonColumnsClassName } from './reason'

type ReasonsHeaderProps = {
  isShopify: boolean
}

const headingClassName =
  'text-xs font-medium uppercase tracking-wide text-neutral-500'

export const ReasonsHeader: React.FC<ReasonsHeaderProps> = ({ isShopify }) => {
  const { t } = useTranslation()

  if (isShopify)
    return (
      <div className={`${shopifyReasonColumnsClassName} pb-2`}>
        <div />
        <p className={`${headingClassName} text-center`}>
          {t('edit_reasons.visible')}
        </p>
        <p className={`${headingClassName} text-center`}>
          {t('edit_reasons.mandatory_comment')}
        </p>
        <p className={headingClassName}>{t('edit_reasons.product_types')}</p>
      </div>
    )

  return (
    <div className={`${reasonColumnsClassName} pb-2`}>
      <div />
      <p className={`${headingClassName} text-center`}>
        {t('edit_reasons.visible')}
      </p>
      <p className={`${headingClassName} text-center`}>
        {t('edit_reasons.mandatory_comment')}
      </p>
    </div>
  )
}
